import Vue from 'vue'
import UserMessageCard from './UserMessageCard.vue'

const UserConstructor = Vue.extend(UserMessageCard)
const userLayer = new UserConstructor({
  el: document.createElement('div')
})
userLayer.vm = userLayer.$mount()
document.body.appendChild(userLayer.$el)

Vue.prototype.$userLayer = userLayer



// WEBPACK FOOTER //
// ./src/components/MessageCard/index.js